import PropTypes from "prop-types";
import React, { useState, useRef, useCallback } from "react";
import { StyledTooltip, StyledTooltipContent } from "./CommonStyles";

const Tooltip = ({ text, children, position = "bottom" }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipStyle, setTooltipStyle] = useState({});
  const triggerRef = useRef(null);

  const calculatePosition = useCallback(() => {
    if (!triggerRef.current) return {};

    const rect = triggerRef.current.getBoundingClientRect();
    const tooltipPadding = 8;

    switch (position) {
      case "top":
        return {
          top: rect.top - tooltipPadding - 5,
          left: rect.left + rect.width / 2,
          transform: "translate(-50%, -100%)",
        };
      case "right":
        return {
          top: rect.top + rect.height / 2,
          left: rect.right + 5,
          transform: "translateY(-50%)",
        };
      case "left":
        return {
          top: rect.top + rect.height / 2,
          left: rect.left - 5,
          transform: "translate(-100%, -50%)",
        };
      case "bottom":
      default:
        return {
          top: rect.bottom + 5,
          left: rect.left + rect.width / 2,
          transform: "translateX(-50%)",
        };
    }
  }, [position]);

  const handleMouseEnter = useCallback(() => {
    const style = calculatePosition();
    setTooltipStyle(style);
    setIsVisible(true);
  }, [calculatePosition]);

  const handleMouseLeave = useCallback(() => {
    setIsVisible(false);
  }, []);

  return (
    <StyledTooltip
      ref={triggerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      <StyledTooltipContent
        position={position}
        data-position={position}
        style={{
          ...tooltipStyle,
          visibility: isVisible ? "visible" : "hidden",
          opacity: isVisible ? 1 : 0,
        }}
      >
        {text}
      </StyledTooltipContent>
    </StyledTooltip>
  );
};

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  position: PropTypes.oneOf(["top", "bottom", "left", "right"]),
};

export default Tooltip;
